import { render } from "./listCard.vue?vue&type=template&id=634450f2"
import script from "./listCard.vue?vue&type=script&lang=js"
export * from "./listCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/lihui/Desktop/project/student_front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__